<template>
    <div class="service-providers-message-sent-step w-100 h-100">
        <b-row
                class="h-100"
                no-gutters
        >
            <b-col
                    :cols="12"
                    :md="6"
                    class="notification-column"
            >
                <div class="notification-wrapper w-100">
                    <div class="notification-icon-wrapper">
                        <i class="far fa-check notification-icon" />
                    </div>

                    <div class="notification-title">
                        Message Sent
                    </div>

                    <div class="notification-subtitle">
                        You'll receive a reply shortly. For immediate assistance, visit our website.
                    </div>

                    <div class="close-button-wrapper">
                        <b-button
                                size="lg"
                                variant="transparent"
                                class="shadow-none bg-white close-button"
                                @click="handleClose"
                        >
                            Close
                        </b-button>
                    </div>
                </div>
            </b-col>
            <b-col
                    :cols="12"
                    :md="6"
                    class="info-card-column"
            >
                <div class="info-card-wrapper">
                    <service-provider-card
                            :service-provider="serviceProvider"
                            variant="detailed"
                    />

                    <div class="disclaimer d-none d-md-block">
                        The websites listed above are independent and we do not guarantee the accuracy, completeness,
                        efficiency, or timeliness of the information contained therein.
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import './MessageSentStep.scss';
    import ServiceProviderCard from "../../ServiceProviderCard/ServiceProviderCard.vue";
    import ServiceProviderAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";

    export default {
        name: "MessageSentStep",
        components: {
            ServiceProviderCard,
        },

        props: {
            serviceProvider: {
                type: ServiceProviderAppResource,
                required: true,
            },
        },

        methods: {
            handleClose() {
                this.$emit('close');
            }
        },
    };
</script>
